import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import './MaterialSymbol.css'

const getFontVariationSettings = (fill, opsz, weight, grad) => {
  return _([
    ['FILL', fill],
    ['opsz', opsz],
    ['wght', weight],
    ['GRAD', grad],
  ])
    .reject(([, value]) => _.isNil(value))
    .map(([label, value]) => `'${label}' ${value}`)
    .join(', ')
}

const MaterialSymbol = React.forwardRef(
  ({ icon, className, fill, size, weight, grad, inline, style, ...props }, ref) => {
    const fillValue = fill === true ? 1 : fill === false ? 0 : fill ? _.clamp(fill, 0, 1) : null
    const fontSize = size ? { fontSize: `${size}px` } : null
    const opszValue = size ? _.clamp(size, 20, 48) : null
    const weightValue = weight ? _.clamp(weight, 0, 700) : null
    const gradValue = grad ? _.clamp(grad, -25, 200) : null

    const fontVariationSettings = getFontVariationSettings(fillValue, opszValue, weightValue, gradValue)

    return (
      <i
        {...props}
        ref={ref}
        className={`material-symbols-outlined ${className || ''} ${inline ? 'inline-symbol' : ''}`}
        style={{ ...fontSize, fontVariationSettings, ...style }}
      >
        {icon}
      </i>
    )
  },
)

MaterialSymbol.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  fill: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  size: PropTypes.oneOf([20, 24, 40, 48]),
  weight: PropTypes.number,
  grad: PropTypes.number,
  inline: PropTypes.bool,
  style: PropTypes.object,
}

export default MaterialSymbol
